<div class="cash-bonanza p-0 flex flex_column">
  <div class="cash-bonanza__header">
    <img
      src="assets/images/bonanaza_image.png"
      class="cash-bonanza__logo"
      alt="Cash Bonanza"
      style="min-height: 150px;"
    />
    <div class="dialog-header-cross cash-bonanza__close" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="cash-bonanza__body">
    <h2 class="cash-bonanza__headline text-center">Turn Your Connections into Cash!</h2>
    <p class="cash-bonanza__intro">
      Know a restaurant? Refer them to EasyEat and earn RM300 cash for each successful sign-up.
    </p>

    <div class="cash-bonanza__content">
      <div class="cash-bonanza__left">
        <ul class="cash-bonanza__list">
          <li>
            <span class="cash-bonanza__icon cash-bonanza__icon--check">✓</span>
            <span>RM300 per restaurant</span>
          </li>
          <li>
            <span class="cash-bonanza__icon cash-bonanza__icon--dollar">$</span>
            <span><strong>Unlimited Rewards</strong></span>
          </li>
          <li>
            <span class="cash-bonanza__icon cash-bonanza__icon--cal">📅</span>
            <span>Ends 31 Mar 2026</span>
          </li>
        </ul>
        <p class="cash-bonanza__tagline">Don't let your network go waste.</p>
      </div>
      <div class="cash-bonanza__right">
        <div class="cash-bonanza__actions">
          <div class="cash-bonanza__illus">
            <img src="assets/images/cash_content.png" alt="" />
          </div>
          <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 40px;">
            <a
            class="cash-bonanza__btn"
            target="_blank"
            rel="noopener noreferrer"
            href="https://forms.gle/j2mpkpQTEaE4cEqx9"
          >
            Referral Form (English)
          </a>
          <a
            class="cash-bonanza__btn"
            target="_blank"
            rel="noopener noreferrer"
            href="https://forms.gle/V2zUVXzkYGCfJp4d8"
          >
            Referral Form (Bahasa)
          </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
